import { createI18n } from 'vue-i18n'
import en from '@/language/en-US.json'

type MessageSchema = typeof en

const i18n = createI18n({
    legacy: false,
    locale: 'en-US',
    fallbackLocale: 'en-US',
    globalInjection: true,
    messages: {
      'en-US': en
    }
  });
  

export default i18n
